import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import masterService from "services/MasterService";

export const initialState = {
  loading: false,
  message: "",
  list: null,
  sublist: null,
  subloading: false,
};

export const productListAll = createAsyncThunk(
  "/product/list",
  async (data, { rejectWithValue }) => {
    try {
      const response = await masterService.getProduct(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    productList: (state, action) => {
      state.loading = true;
      state.list = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(productListAll.pending, (state) => {
        state.loading = false;
      })
      .addCase(productListAll.fulfilled, (state, action) => {
        state.loading = true;
        state.list = action.payload;
      });
  },
});

export const { productList } = productSlice.actions;

export default productSlice.reducer;
